module.exports = __webpack_public_path__ + "static/img/zdtzzz.e7ab37e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/zdtzzz.png
// module id = Qroj
// module chunks = 0